<svg width="100%" height="100%" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_b_10793_448842)">
        <rect width="48" height="48" rx="24" fill="url(#paint0_linear_10793_448842)" fill-opacity="0.8" />
        <rect x="1" y="1" width="46" height="46" rx="23" stroke="url(#paint1_linear_10793_448842)" stroke-width="2" />
        <g clip-path="url(#clip0_10793_448842)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.5495 23.91C15.5092 23.91 15.4765 23.9428 15.4765 23.9831C15.4765 24.0235 15.5092 24.0562 15.5495 24.0562C15.5899 24.0562 15.6226 24.0235 15.6226 23.9831C15.6226 23.9428 15.5899 23.91 15.5495 23.91ZM13 23.9831C13 22.575 14.1415 21.4336 15.5495 21.4336C16.9576 21.4336 18.099 22.575 18.099 23.9831C18.099 25.3912 16.9576 26.5326 15.5495 26.5326C14.1415 26.5326 13 25.3912 13 23.9831Z"
                fill="white"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M23.9999 23.91C23.9596 23.91 23.9269 23.9428 23.9269 23.9831C23.9269 24.0235 23.9596 24.0562 23.9999 24.0562C24.0403 24.0562 24.073 24.0235 24.073 23.9831C24.073 23.9428 24.0403 23.91 23.9999 23.91ZM21.4504 23.9831C21.4504 22.575 22.5919 21.4336 23.9999 21.4336C25.408 21.4336 26.5495 22.575 26.5495 23.9831C26.5495 25.3912 25.408 26.5326 23.9999 26.5326C22.5919 26.5326 21.4504 25.3912 21.4504 23.9831Z"
                fill="white"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M32.4506 23.91C32.4103 23.91 32.3776 23.9428 32.3776 23.9831C32.3776 24.0235 32.4103 24.0562 32.4506 24.0562C32.491 24.0562 32.5237 24.0235 32.5237 23.9831C32.5237 23.9428 32.491 23.91 32.4506 23.91ZM29.9011 23.9831C29.9011 22.575 31.0426 21.4336 32.4506 21.4336C33.8587 21.4336 35.0001 22.575 35.0001 23.9831C35.0001 25.3912 33.8587 26.5326 32.4506 26.5326C31.0426 26.5326 29.9011 25.3912 29.9011 23.9831Z"
                fill="white"
            />
        </g>
    </g>
    <defs>
        <filter
            id="filter0_b_10793_448842"
            x="-4"
            y="-4"
            width="56"
            height="56"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
        >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
            <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_10793_448842" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_10793_448842" result="shape" />
        </filter>
        <linearGradient
            id="paint0_linear_10793_448842"
            x1="24.2892"
            y1="48"
            x2="24.2892"
            y2="-7.49416e-07"
            gradientUnits="userSpaceOnUse"
        >
            <stop stop-color="#2F3235" />
            <stop offset="0.4" stop-color="#585D63" />
            <stop offset="1" stop-color="#9D9E9F" />
        </linearGradient>
        <linearGradient id="paint1_linear_10793_448842" x1="24" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
            <stop stop-color="white" />
            <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <clipPath id="clip0_10793_448842">
            <rect width="22" height="22" fill="white" transform="translate(13 13)" />
        </clipPath>
    </defs>
</svg>
